import { events, serviceQueries } from '@estee/elc-service-bus';
import { CreateServiceQuery } from '~api/ServiceQueries/CreateServiceQuery';
import ServiceBusController from '~setup/ServiceBusController';

const controller = new ServiceBusController();
const onEvents = [
    [events.REMOVE_ITEM, 'cartItemRemoved'],
    [events.CART_UPDATED, 'cartUpdated'],
    [events.CART_BADGE_CLICKED, 'cartOpened']
];

const queries = [[serviceQueries.GET_MANUAL_OFFER, 'get.manual.offer']];

onEvents.forEach(([event, fn]) =>
    //@ts-ignore
    window.document.addEventListener(event, ({ detail }) => controller[fn]?.(detail))
);

queries.forEach(([query, fn]) => CreateServiceQuery(query, controller));
